import { MyOrderSliceState } from 'src/core/models'

const myOrdersState: MyOrderSliceState = {
  myOrders: {
    loading: false,
    list: [],
    selected: [],
    filtered: [],
    filterText: null,
    error: null
  },
  getCertificates: {
    loading: false,
    success: false,
    data: []
  },
  getOne: {
    loading: false,
    error: null,
    order: null,
    orderItem: null
  },
  getAllOrderItems: {
    loading: false,
    error: null,
    order: null,
    orderItems: []
  }
}
export { myOrdersState as initialState }
